export default __webpack_public_path__ + "static/media/menfashion.2946b749.webp";